import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=204b48be&scoped=true&slot-scope=scope&"
import script from "./Position.vue?vue&type=script&lang=js&"
export * from "./Position.vue?vue&type=script&lang=js&"
import style0 from "./Position.vue?vue&type=style&index=0&id=204b48be&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b48be",
  null
  
)

export default component.exports